import { Divider, Stack } from '@ace-clublabs/shared-component-library';
import { CartProductCode } from '@ace-clublabs/common-membership-api-types';
import { ReviewItem } from './ReviewItem';
import { useContext } from 'react';
import { MembershipAppStateContext } from '../MembershipAppState/MembershipAppState';

export const TaxSection = () => {
  const { sessionData } = useContext(MembershipAppStateContext);
  const salesTax = sessionData?.priceCart?.salesTax || 0;

  return (
    <Stack className="tax-section">
      <ReviewItem
        title="Sales tax"
        id="sales-tax"
        code={CartProductCode.SALESTAX}
        price={salesTax}
        description="Sales tax"
        className="sales-tax-item"
      />
      <Divider variant="fullWidth" sx={{ margin: '1rem 0' }} />
    </Stack>
  );
};
